<template>
  <div class="index">
    <div class="container_wrap">
      <Header />
      
      <div class="index_container">
        <!-- 要闻 -->
        <div class="home_pre clearfloat">
          <div class="home_pre_l fl"><span>要闻头条</span></div>
          <div class="inner">
            <el-carousel height="58px" direction="vertical" :interval="2500" indicator-position="none">
              <el-carousel-item v-for="item in newsTop" :key="item.id">
                <p class="single-line">
                  <router-link class="intro-btn" :to="`/zy/detail?id=${item.id}&navName=新闻中心&groupName=公司动态`">{{ item.title }}</router-link>
                </p>
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>

        <div class="sec01">
          <el-row :gutter="15">
            <el-col :span="10">
              <div class="sec01_l_t">
                <el-carousel height="320px" indicator-position="none">
                  <el-carousel-item v-for="item in sec01LImg" :key="item.id">
                    <div class="sec01_l_t_w">
                      <a :href="`/zy/detail?id=${item.id}&navName=新闻中心&groupName=公司动态`">
                        <img :src="item.img" alt="">
                        <p>{{item.title}}</p>
                      </a>
                    </div>
                    <h3 class="small">{{ item }}</h3>
                  </el-carousel-item>
                </el-carousel>

                <!-- <div class="sec01_l_t_b">
                  <el-row :gutter="12">
                    <el-col class="sec01_l_t_b_img" :span="8">
                      <a href="/zy/detail?id=1&navName=公司概况&groupName=公司概况&noList=1"><img src="../assets/img/sec01_l_m_img01.png" alt=""></a>
                    </el-col>
                    <el-col class="sec01_l_t_b_img" :span="8">
                      <a href="/member"><img src="../assets/img/sec01_l_m_img02.png" alt=""></a>
                    </el-col>
                    <el-col class="sec01_l_t_b_img" :span="8">
                      <a href="/zy/list?id=2&navName=公司概况&groupName=组织机构"><img src="../assets/img/sec01_l_m_img03.png" alt=""></a>
                    </el-col>
                    <el-col class="sec01_l_t_b_img" :span="8">
                      <a href="/zy/list?id=5&navName=公司概况&groupName=大事记"><img src="../assets/img/sec01_l_m_img04.png" alt=""></a>
                    </el-col>
                    <el-col class="sec01_l_t_b_img" :span="8">
                      <a href="/zy/list?id=3&navName=公司概况&groupName=公司荣誉"><img src="../assets/img/sec01_l_m_img05.png" alt=""></a>
                    </el-col>
                    <el-col class="sec01_l_t_b_img" :span="8">
                      <a href="/zy/list?id=26&navName=学习园地&groupName=学习园地"><img src="../assets/img/sec01_l_m_img06.png" alt=""></a>
                    </el-col>
                  </el-row>
                </div> -->
              </div>
              <!-- <div class="sec_notic clearfloat">
                <div class="sec_notic_l fl">
                  <a href="/zy/list?id=9&navName=新闻中心&groupName=公示公告"><span>公示公告</span></a>
                </div>
                <div class="sec_notic_inner">
                  <ul class="news_list news_list01"> 
                    <li v-for="(item,index) in newsGsgg" :key="index">
                      <p class="news_list_inner single-line">
                        <a :href="`/zy/detail?id=${item.id}&navName=新闻中心&groupName=公示公告`">{{ item.title }}</a>
                      </p>
                    </li>
                  </ul>
                </div>
              </div> -->
            </el-col>
            <el-col :span="14">
              <div class="sec_news_w">
                <div class="sec_news_tit">
                  <span><a href="/zy/list?id=7&navName=新闻中心&groupName=公司动态">公司动态</a></span>
                </div>
                <div class="sec_news_g">
                  <ul class="news_list news_list02">
                    <li v-for="(item,index) in newsJtdt" :key="index" :class="dayjs(item.update_time).format('MM-DD')==dayjs().format('MM-DD') ? 'news_new' : ''">
                      <div class="news_list_time fr">{{ dayjs(item.update_time).format('MM-DD') }}</div>
                      <p class="news_list_inner single-line">
                        <a :href="`/zy/detail?id=${item.id}&navName=新闻中心&groupName=公司动态`">{{item.title}}</a>
                      </p>
                    </li>
                  </ul>
                </div>
              </div>

              <!-- <div class="sec_news_w" style="margin-top: 50px;">
                <div class="sec_notic clearfloat">
                  <div class="sec_notic_l fl">
                    <a href="/zy/list?id=9&navName=新闻中心&groupName=公示公告"><span>公示公告</span></a>
                  </div>
                  <div class="sec_notic_inner">
                    <ul class="news_list news_list01"> 
                      <li v-for="(item,index) in newsGsgg" :key="index">
                        <p class="news_list_inner single-line">
                          <a :href="`/zy/detail?id=${item.id}&navName=新闻中心&groupName=公示公告`">{{ item.title }}</a>
                        </p>
                      </li>
                    </ul>
                  </div>
                </div>
              </div> -->

              <!-- <div class="sec_news_w" style="margin-top: 10px;">
                <div class="sec_news_tit">
                  <span><a href="/zy/list?id=8&navName=新闻中心&groupName=子%28分%29公司动态">子(分)公司动态</a></span>
                </div>
                <div class="sec_news_g">
                  <ul class="news_list news_list02">
                    <li v-for="(item,index) in newsFgsdt" :key="index" :class="dayjs(item.update_time).format('MM-DD')==dayjs().format('MM-DD') ? 'news_new' : ''">
                      <div class="news_list_time fr">{{ dayjs(item.update_time).format('MM-DD') }}</div>
                      <p class="news_list_inner single-line">
                        <a :href="`/zy/detail?id=${item.id}&navName=新闻中心&groupName=子(分)公司动态`">{{item.title}}</a>
                      </p>
                    </li>
                  </ul>
                </div>
              </div> -->

            </el-col>
          </el-row>


          <!-- <el-row>
            <el-col :span="24">

              <div class="sec_notic clearfloat" style="margin: 20px 0px;">
                <div class="sec_notic_l fl">
                  <a href="/zy/list?id=9&navName=新闻中心&groupName=公示公告"><span>专题链接</span></a>
                </div>
                <div class="sec_notic_inner">
                  <ul class="news_list news_list01"> 
                    <li v-for="(item,index) in ztSrc" :key="index">
                      <p class="news_list_inner single-line">
                        <a :href="`${item.url}`" target="_blank">{{ item.name }}</a>
                      </p>
                    </li>
                  </ul>
                </div>
              </div>

            </el-col>
          </el-row> -->

        </div>

        <!-- <div class="sec02">
          <div class="sec_hd">
            <img src="../assets/img/ghlyw_05.jpg" alt="">
          </div>
          <el-row :gutter="8" class="index_sec_jtyw">
            <el-col :span="4">
              <a href="/zy/list?id=14&navName=集团业务&groupName=公路"><img src="../assets/img/yw_03.jpg" alt=""></a>
            </el-col>
            <el-col :span="4">
              <a href="/zy/list?id=15&navName=集团业务&groupName=航空"><img src="../assets/img/yw_05.jpg" alt=""></a>
            </el-col>
            <el-col :span="4">
              <a href="/zy/list?id=16&navName=集团业务&groupName=旅游"><img src="../assets/img/yw_09.jpg" alt=""></a>
            </el-col>
            <el-col :span="4">
              <a href="/zy/list?id=17&navName=集团业务&groupName=金融"><img src="../assets/img/yw_11.jpg" alt=""></a>
            </el-col>
            <el-col :span="4">
              <a href="/zy/list?id=18&navName=集团业务&groupName=保险"><img src="../assets/img/yw_07.jpg" alt=""></a>
            </el-col>
            <el-col :span="4">
              <a href="/zy/list?id=19&navName=集团业务&groupName=融资"><img src="../assets/img/yw_13.jpg" alt=""></a>
            </el-col>
          </el-row>
        </div> -->

        <el-row class="index_d_img" style="margin-top: 15px;">
          <el-col :span="24">
            <img src="../assets/img/img_d_01.png" alt="">
            <img src="../assets/img/img_d_02.jpg" alt="">
          </el-col>
        </el-row>

        <el-row class="sec03" :gutter="15" style="margin-bottom: 15px; margin-top: 30px;">
          <el-col :span="8">
            <div class="sec_wrap">
              <div class="sec_tit">
                <span><a href="/special">专题专栏</a></span>
              </div>
              <div class="sec_wrap_c sec_zl">
                <div class="swiper-container">
                  <div class="swiper-wrapper">
                      <div class="swiper-slide" v-for="(item,index) in newsZtZl" :key="index">
                        <a :href="`/zy/list?id=${item.id}&navName=专题专栏&groupName=${item.name}`"><img :src="item.img" alt=""></a>
                      </div>
                  </div>
                  <!-- 如果需要分页器 -->
                  <!-- <div class="swiper-pagination"></div> -->
                  
                  <!-- 如果需要导航按钮 -->
                  <!-- <div class="swiper-button-prev"></div>
                  <div class="swiper-button-next"></div> -->
                  
                  <!-- 如果需要滚动条 -->
                  <!-- <div class="swiper-scrollbar"></div> -->
              </div>
              </div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="sec_wrap">
              <div class="sec_tit">
                <span><a href="/zy/list?id=14&navName=党建之窗&groupName=党建工作">党建工作</a></span>
              </div>
              <div class="sec_wrap_c">
                <ul class="news_list news_list01"> 
                  <li v-for="(item,index) in newsDjgz"  :key="index">
                    <p class="news_list_inner single-line">
                      <a :href="`/zy/detail?id=${item.id}&navName=党建之窗&groupName=党建工作`">{{ item.title }}</a>
                    </p>
                  </li>
                </ul>
              </div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="sec_wrap">
              <div class="sec_tit">
                <span><a href="/zy/list?id=14&navName=党建之窗&groupName=纪检监察">纪检监察</a></span>
              </div>
              <div class="sec_wrap_c">
                <ul class="news_list news_list01"> 
                  <li v-for="(item,index) in newsJjjc"  :key="index">
                    <p class="news_list_inner single-line">
                      <a :href="`/zy/detail?id=${item.id}&navName=党建之窗&groupName=纪检监察`">{{ item.title }}</a>
                    </p>
                  </li>
                </ul>
              </div>
            </div>
          </el-col>
        </el-row>

        <el-row class="sec_jtdt" :gutter="10">
          <el-col :span="6">
            <div class="sec_wrap">
              <div class="sec_tit">
                <span><a href="/zy/list?id=26&navName=学习园地&groupName=学习园地">学习园地</a></span>
              </div>
              <ul class="news_list news_list01"> 
                <li v-for="(item,index) in newsXxyd"  :key="index">
                  <p class="news_list_inner single-line">
                    <a :href="`/zy/detail?id=${item.id}&navName=学习园地&groupName=学习园地`">{{ item.title }}</a>
                  </p>
                </li>
              </ul>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="sec_wrap">
              <div class="sec_tit">
                <span><a href="/zy/list?id=10&navName=新闻中心&groupName=政策法规">政策法规</a></span>
              </div>
              <ul class="news_list news_list01"> 
                <li v-for="(item,index) in newsZcfg"  :key="index">
                  <p class="news_list_inner single-line">
                    <a :href="`/zy/detail?id=${item.id}&navName=政策法规&groupName=政策法规`">{{ item.title }}</a>
                  </p>
                </li>
              </ul>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="sec_wrap">
              <div class="sec_tit">
                <span><a href="/zy/list?id=13&navName=新闻中心&groupName=行业动态">行业动态</a></span>
              </div>
              <ul class="news_list news_list01"> 
                <li v-for="(item,index) in newsHydt"  :key="index">
                  <p class="news_list_inner single-line">
                    <a :href="`/zy/detail?id=${item.id}&navName=新闻中心&groupName=行业动态`">{{ item.title }}</a>
                  </p>
                </li>
              </ul>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="sec_wrap">
              <div class="sec_tit">
                <span><a href="/zy/list?id=11&navName=新闻中心&groupName=媒体聚焦">招商投标</a></span>
              </div>
              <ul class="news_list news_list01"> 
                <li v-for="(item,index) in newsMtjj"  :key="index">
                  <p class="news_list_inner single-line">
                    <a :href="`/zy/detail?id=${item.id}&navName=新闻中心&groupName=媒体聚焦`">{{ item.title }}</a>
                  </p>
                </li>
              </ul>
            </div>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <div class="sec_wrap">
              <div class="sec_tit">
                <span><a href="/zy/list?id=7&navName=新闻中心&groupName=公司动态">项目展示</a></span>
              </div>
              <div class="sec_scroll_jtdt sec_scroll">
                <vue-seamless-scroll 
                  :data="scrollList"
                  :class-option="classOption" 
                  class="table-content">
                  <ul class="item_list clearfloat">
                      <li v-for="(item,index) in scrollList"  :key="index">
                        <a :href="`/zy/detail?id=${item.id}&navName=新闻中心&groupName=公司动态`">
                          <div class="pic"><img :src="item.img" alt=""></div>
                        </a>
                      </li>
                  </ul>
                </vue-seamless-scroll>
              </div>
            </div>
          </el-col>
        </el-row>

        <!-- <el-row style="margin-top: 15px;">
          <el-col :span="24">
            <div class="sec_wrap">
              <div class="sec_tit">
                <span><a href="/zy/list?id=12&navName=新闻中心&groupName=视频集锦">视频集锦</a></span>
              </div>
              <div class="sec_scroll_jtdt sec_scroll">
                <vue-seamless-scroll 
                  :data="scrollList"
                  :class-option="classOption" 
                  class="table-content">
                  <ul class="item_list clearfloat">
                      <li v-for="(item,index) in scrollList"  :key="index">
                        <a :href="`/zy/detail?id=${item.id}&navName=新闻中心&groupName=视频集锦`">
                          <div class="pic"><img :src="item.img" alt=""></div>
                        </a>
                      </li>
                  </ul>
                </vue-seamless-scroll>
              </div>
            </div>
          </el-col>
        </el-row> -->

        <el-row style="margin-top: 15px;">
          <el-col :span="24">
            <div class="sec_wrap">
              <div class="sec_tit">
                <span><a href="/zy/list?id=7&navName=新闻中心&groupName=公司动态">合作单位</a></span>
              </div>
              <div class="sec_scroll_jtdt sec_scroll" style="height: 200px;">
                <ul class="sec_link_l clearfloat" style="margin-top: 20px;">
                  <li><a href="http://www.mot.gov.cn/" target="_blank"><img src="../assets/img/link01.gif" alt=""></a></li>
                  <li><a href="http://www.gansu.gov.cn/" target="_blank"><img src="../assets/img/link02.gif" alt=""></a></li>
                  <li><a href="http://jtys.gansu.gov.cn" target="_blank"><img src="../assets/img/link04.gif" alt=""></a></li>
                  <li><a href="http://www.gs-highway.com/" target="_blank"><img src="../assets/img/link05.gif" alt=""></a></li>
                  <li><a href="http://www.zgjtb.com/" target="_blank"><img src="../assets/img/link030.gif" alt=""></a></li>
                  <li><a href="http://www.sdpc.gov.cn/" target="_blank"><img src="../assets/img/link_f_img01.gif" alt=""></a></li>
                  <li><a href="http://www.pbc.gov.cn/" target="_blank"><img src="../assets/img/link_f_img02.gif" alt=""></a></li>
                  <li><a href="http://www.cbrc.gov.cn/" target="_blank"><img src="../assets/img/link_f_img03.gif" alt=""></a></li>
                  <li><a href="http://www.csrc.gov.cn/" target="_blank"><img src="../assets/img/link_f_img04.gif" alt=""></a></li>
                  <li><a href="http://www.nafmii.org.cn/" target="_blank"><img src="../assets/img/link_f_img05.gif" alt=""></a></li>
                </ul>
                <ul class="sec_link_l clearfloat">
                  <li>
                    <el-select v-model="value01" placeholder="请选择">
                      <el-option
                        v-for="item in options01"
                        :key="item.name"
                        :label="item.name"
                        :value="item.url">
                        <a :href="item.url" target="_blank" style="display: block;">{{item.name}}</a>
                      </el-option>
                    </el-select>
                  </li>
                  <li>
                    <el-select v-model="value02" placeholder="请选择">
                      <el-option
                        v-for="item in options02"
                        :key="item.name"
                        :label="item.name"
                        :value="item.url">
                        <a :href="item.url" target="_blank" style="display: block;">{{item.name}}</a>
                      </el-option>
                    </el-select>
                  </li>
                  <li>
                    <el-select v-model="value03" placeholder="请选择">
                      <el-option
                        v-for="item in options03"
                        :key="item.name"
                        :label="item.name"
                        :value="item.url">
                        <a :href="item.url" target="_blank" style="display: block;">{{item.name}}</a>
                      </el-option>
                    </el-select>
                  </li>
                  <li>
                    <el-select v-model="value04" placeholder="请选择">
                      <el-option
                        v-for="item in options04"
                        :key="item.name"
                        :label="item.name"
                        :value="item.url">
                        <a :href="item.url" target="_blank" style="display: block;">{{item.name}}</a>
                      </el-option>
                    </el-select>
                  </li>
                  <li>
                    <el-select v-model="value05" placeholder="请选择">
                      <el-option
                        v-for="item in options05"
                        :key="item.name"
                        :label="item.name"
                        :value="item.url">
                        <a :href="item.url" target="_blank" style="display: block;">{{item.name}}</a>
                      </el-option>
                    </el-select>
                  </li>
                </ul>
              </div>
            </div>
          </el-col>
        </el-row>

        <el-row style="margin-top: 15px;">
          <el-col :span="24">
            <div class="sec_wrap">
              <div class="sec_tit">
                <span><a href="/zy/list?id=12&navName=新闻中心&groupName=视频集锦">旗下公司</a></span>
              </div>
              <div class="sec_scroll">
                <div class="sec_zfgs" style="margin-top: 20px; padding: 0 15px 15px 15px">
                  <el-row class="sec_zfgs_list" :gutter="6">
                    <el-col :span="6">
                      <a class="single-line" href="#" target="_blank">甘肃德源房地产开发有限公司</a>
                    </el-col>
                    <el-col :span="6">
                      <a class="single-line" href="#" target="_blank">甘肃公航旅颐源置业有限公司</a>
                    </el-col>
                    <el-col :span="6">
                      <a class="single-line" href="#" target="_blank">兰州市安宁城投房地产开发有限公司</a>
                    </el-col>
                  </el-row>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>

        <!-- 子分公司 -->
        <!-- <div class="sec_zfgs" style="margin-top: 20px;">
          <div class="sec_hd">
            <img src="../assets/img/ghfgs_09.jpg" alt="">
          </div>
          <el-row class="sec_zfgs_list" :gutter="6">
            <el-col :span="6" v-for="(item, index) in listZfgs" :key="index">
              <a class="single-line" :href="item.url" target="_blank">{{ item.name }}</a>
            </el-col>
            <el-col :span="6">
              <a class="single-line" href="#" target="_blank">甘肃德源房地产开发有限公司</a>
            </el-col>
            <el-col :span="6">
              <a class="single-line" href="#" target="_blank">甘肃公航旅颐源置业有限公司</a>
            </el-col>
            <el-col :span="6">
              <a class="single-line" href="#" target="_blank">兰州市安宁城投房地产开发有限公司</a>
            </el-col>
          </el-row>
        </div> -->

        <!-- 友=友情链接 -->
        <!-- <div class="sec_link">
          <ul class="sec_link_l clearfloat">
            <li><a href="http://www.mot.gov.cn/" target="_blank"><img src="../assets/img/link01.gif" alt=""></a></li>
            <li><a href="http://www.gansu.gov.cn/" target="_blank"><img src="../assets/img/link02.gif" alt=""></a></li>
            <li><a href="http://jtys.gansu.gov.cn" target="_blank"><img src="../assets/img/link04.gif" alt=""></a></li>
            <li><a href="http://www.gs-highway.com/" target="_blank"><img src="../assets/img/link05.gif" alt=""></a></li>
            <li><a href="http://www.zgjtb.com/" target="_blank"><img src="../assets/img/link030.gif" alt=""></a></li>
            <li><a href="http://www.sdpc.gov.cn/" target="_blank"><img src="../assets/img/link_f_img01.gif" alt=""></a></li>
            <li><a href="http://www.pbc.gov.cn/" target="_blank"><img src="../assets/img/link_f_img02.gif" alt=""></a></li>
            <li><a href="http://www.cbrc.gov.cn/" target="_blank"><img src="../assets/img/link_f_img03.gif" alt=""></a></li>
            <li><a href="http://www.csrc.gov.cn/" target="_blank"><img src="../assets/img/link_f_img04.gif" alt=""></a></li>
            <li><a href="http://www.nafmii.org.cn/" target="_blank"><img src="../assets/img/link_f_img05.gif" alt=""></a></li>
          </ul>
          <ul class="sec_link_l clearfloat">
            <li>
              <el-select v-model="value01" placeholder="请选择">
                <el-option
                  v-for="item in options01"
                  :key="item.name"
                  :label="item.name"
                  :value="item.url">
                  <a :href="item.url" target="_blank" style="display: block;">{{item.name}}</a>
                </el-option>
              </el-select>
            </li>
            <li>
              <el-select v-model="value02" placeholder="请选择">
                <el-option
                  v-for="item in options02"
                  :key="item.name"
                  :label="item.name"
                  :value="item.url">
                  <a :href="item.url" target="_blank" style="display: block;">{{item.name}}</a>
                </el-option>
              </el-select>
            </li>
            <li>
              <el-select v-model="value03" placeholder="请选择">
                <el-option
                  v-for="item in options03"
                  :key="item.name"
                  :label="item.name"
                  :value="item.url">
                  <a :href="item.url" target="_blank" style="display: block;">{{item.name}}</a>
                </el-option>
              </el-select>
            </li>
            <li>
              <el-select v-model="value04" placeholder="请选择">
                <el-option
                  v-for="item in options04"
                  :key="item.name"
                  :label="item.name"
                  :value="item.url">
                  <a :href="item.url" target="_blank" style="display: block;">{{item.name}}</a>
                </el-option>
              </el-select>
            </li>
            <li>
              <el-select v-model="value05" placeholder="请选择">
                <el-option
                  v-for="item in options05"
                  :key="item.name"
                  :label="item.name"
                  :value="item.url">
                  <a :href="item.url" target="_blank" style="display: block;">{{item.name}}</a>
                </el-option>
              </el-select>
            </li>
          </ul>


        </div> -->
        

      </div>

      <Footer />
    </div>

    <!-- 悬浮框 -->
    <!-- <div class="tan_right">
      <a href="http://www.gscq.com.cn/zt/hg2020/gsgh-27/index.html" target="_blank"><img src="../assets/img/tan_r_img01.png" alt=""></a>
      <a href="http://www.gscq.com.cn/index.php?s=neplatform&amp;c=category&amp;id=140" target="_blank"><img src="../assets/img/tan_r_img02.png" alt=""></a>
      <a href="http://gscq.com.cn/zt/2020/" target="_blank"><img src="../assets/img/tan_r_img03.png" alt=""></a>
      <a href="http://www.gscq.com.cn/zt/hg/" target="_blank"><img src="../assets/img/tan_r_img04.jpg" alt=""></a>
      <a href="/jyxc" target="_blank"><img src="../assets/img/tan_r_img05.png" alt=""></a>
    </div> -->

  </div>
</template>

<script>
import Header from "@/components/header.vue";
import Footer from "@/components/footer.vue";
import Swiper from "swiper"
import vueSeamlessScroll from 'vue-seamless-scroll'
// import 'swiper/swiper.scss';

export default {
  name: 'index',
  components: {
    Header,
    vueSeamlessScroll,
    Footer
    // Swiper
  },
  data(){
    return {
      newsTop: [],
      sec01LImg: [],
      newsJtdt: [],
      newsFgsdt: [],
      newsGsgg: [],
      newsZtZl: [],
      newsDjgz: [],
      newsJjjc: [],
      newsXxyd: [],
      newsZcfg: [],
      newsHydt: [],
      newsMtjj: [],
      listZfgs: [],
      scrollList: [],
      ztSrc: [{
        name: '甘肃公航旅供应链管理有限公司引入外部股东项目',
        url: 'http://www.gscq.com.cn/zt/hg2020/gsgh-27/index.html'
      }, {
        name: '甘肃省产权交易所',
        url: 'http://www.gscq.com.cn/index.php?s=neplatform&amp;c=category&amp;id=140'
      }, {
        name: '甘肃省属国有企业2020年资产出让项目推介',
        url: 'http://gscq.com.cn/zt/2020/'
      }, {
        name: '甘肃省属国有企业混合所有制推介',
        url: 'http://www.gscq.com.cn/zt/hg/'
      }, {
        name: '我为公航旅“十四五”规划建言献策',
        url: '/jyxc'
      }],
      classOption: {
        limitMoveNum: 2,
        direction: 2,
      },
      options01: [
        {
          name: '外交部',
          url: 'http://www.fmprc.gov.cn'
        },
        {
          name: '国防部',
          url: 'http://www.mod.gov.cn/'
        },
        {
          name: '发展改革委',
          url: 'http://www.ndrc.gov.cn/'
        },
        {
          name: '教育部',
          url: 'http://www.moe.edu.cn/'
        },
        {
          name: '科技部',
          url: 'http://www.most.gov.cn/'
        },
        {
          name: '工业和信息化部',
          url: 'http://www.miit.gov.cn/'
        },
        {
          name: '自然资源部',
          url: 'http://www.mnr.gov.cn/'
        },
        {
          name: '公安部',
          url: 'http://www.mps.gov.cn/'
        },
        {
          name: '民政部',
          url: 'http://www.mca.gov.cn'
        },
        {
          name: '司法部',
          url: 'http://www.moj.gov.cn'
        },
        {
          name: '财政部',
          url: 'http://www.mof.gov.cn'
        },
        {
          name: '人力资源社会保障部',
          url: 'http://www.mohrss.gov.cn'
        },
        {
          name: '生态环境部',
          url: 'http://www.mee.gov.cn'
        },
        {
          name: '住房城乡建设部',
          url: 'http://www.mohurd.gov.cn'
        },
        {
          name: '交通运输部',
          url: 'http://www.mot.gov.cn'
        },
        {
          name: '水利部',
          url: 'http://www.mwr.gov.cn/'
        },
        {
          name: '农业农村部',
          url: 'http://www.moa.gov.cn/'
        },
        {
          name: '商务部',
          url: 'http://www.mofcom.gov.cn'
        },
        {
          name: '文化旅游部',
          url: 'http://www.mct.gov.cn/'
        },
        {
          name: '国家卫生健康委员会',
          url: 'http://www.nhc.gov.cn'
        },
        {
          name: '应急管理部',
          url: 'http://www.chinasafety.gov.cn/'
        },
        {
          name: '人民银行',
          url: 'http://www.pbc.gov.cn'
        },
        {
          name: '审计署',
          url: 'http://www.audit.gov.cn/'
        },
        {
          name: '国资委',
          url: 'http://www.sasac.gov.cn/index.html'
        },
        {
          name: '海关总署',
          url: 'http://www.customs.gov.cn/publish/portal0/'
        },
        {
          name: '税务总局',
          url: 'http://www.chinatax.gov.cn/'
        },
        {
          name: '国家市场监督管理总局',
          url: 'http://www.aqsiq.gov.cn/'
        },
        {
          name: '国家广播电视总局',
          url: 'http://www.sapprft.gov.cn/'
        },
        {
          name: '体育总局',
          url: 'http://www.sport.gov.cn/'
        },
        {
          name: '统计局',
          url: 'http://www.stats.gov.cn/'
        },
        {
          name: '知识产权局',
          url: 'http://www.sipo.gov.cn/'
        },
        {
          name: '宗教局',
          url: 'http://www.sara.gov.cn/'
        },
        {
          name: '参事室',
          url: 'http://www.counsellor.gov.cn/'
        },
        {
          name: '国管局',
          url: 'http://www.ggj.gov.cn/'
        },
        {
          name: '版权局',
          url: 'http://www.ncac.gov.cn/'
        },
        {
          name: '法制办',
          url: 'http://www.chinalaw.gov.cn/'
        },
        {
          name: '国务院研究室',
          url: 'http://www.gov.cn/gjjg/2005-12/26/content_137261.htm'
        },
        {
          name: '台办',
          url: 'http://www.gwytb.gov.cn/'
        },
        {
          name: '新闻办',
          url: 'http://www.scio.gov.cn/'
        },
        {
          name: '新华社',
          url: 'http://www3.xinhuanet.com/'
        },
        {
          name: '中科院',
          url: 'http://www.cas.cn/'
        },
        {
          name: '社科院',
          url: 'http://cass.cssn.cn/'
        },
        {
          name: '工程院',
          url: 'http://www.cae.cn/'
        },
        {
          name: '发展研究中心',
          url: 'http://www.drc.gov.cn/'
        },
        {
          name: '中央党校',
          url: 'http://www.nsa.gov.cn/'
        },
        {
          name: '气象局',
          url: 'http://www.cma.gov.cn/'
        },
        {
          name: '地震局',
          url: 'http://www.cea.gov.cn/'
        },
        {
          name: '证监会',
          url: 'http://www.csrc.gov.cn/pub/newsite/'
        }
      ],
      options02: [
        {
          name: '省发展改革委',
          url: 'http://fzgg.gansu.gov.cn/'
        },
        {
          name: '省教育厅',
          url: 'http://jyt.gansu.gov.cn/'
        },
        {
          name: '省科技厅',
          url: 'http://kjt.gansu.gov.cn/'
        },
        {
          name: '省工信厅',
          url: 'http://gxt.gansu.gov.cn/'
        },
        {
          name: '省民族事务委员会',
          url: 'http://mzsw.gansu.gov.cn/'
        },
        {
          name: '省公安厅',
          url: 'http://gat.gansu.gov.cn/'
        },
        {
          name: '省民政厅',
          url: 'http://mzt.gansu.gov.cn/'
        },
        {
          name: '省司法厅',
          url: 'http://sft.gansu.gov.cn/'
        },
        {
          name: '省财政厅',
          url: 'http://czt.gansu.gov.cn/'
        },
        {
          name: '省人社厅',
          url: 'http://rst.gansu.gov.cn/'
        },
        {
          name: '省自然资源厅',
          url: 'http://zrzy.gansu.gov.cn/'
        },
        {
          name: '省生态环境厅',
          url: 'http://sthj.gansu.gov.cn/'
        },
        {
          name: '省住建厅',
          url: 'http://zjt.gansu.gov.cn/'
        },
        {
          name: '省交通运输厅',
          url: 'http://jtys.gansu.gov.cn/'
        },
        {
          name: '省水利厅',
          url: 'http://slt.gansu.gov.cn/'
        },
        {
          name: '省农业农村厅',
          url: 'http://nync.gansu.gov.cn/'
        },
        {
          name: '省商务厅',
          url: 'http://swt.gansu.gov.cn/'
        },
        {
          name: '省文旅厅',
          url: 'http://wlt.gansu.gov.cn/'
        },
        {
          name: '省卫生健康委',
          url: 'http://wsjk.gansu.gov.cn/'
        },
        {
          name: '省退役军人厅',
          url: 'http://tyjr.gansu.gov.cn/'
        },
        {
          name: '省应急厅',
          url: 'http://yjgl.gansu.gov.cn/'
        },
        {
          name: '省审计厅',
          url: 'http://sjt.gansu.gov.cn/'
        },
        {
          name: '省政府外事办',
          url: 'http://wsb.gansu.gov.cn/'
        }
      ],
      options03: [
        {
          name: '金川集团有限公司',
          url: 'http://www.jnmc.com/'
        },
        {
          name: '酒泉钢铁集团',
          url: 'http://www.jiugang.com/'
        },
        {
          name: '白银有色集团股份有限公司',
          url: 'http://www.bynmc.com/'
        },
        {
          name: '甘肃建投',
          url: 'http://www.gsjtw.cc/'
        },
        {
          name: '甘肃省公路航空旅游投资集团有限公司',
          url: 'http://www.ghatg.com/'
        }
      ],
      options04: [
        {
          name: '浙江省交通投资集团有限公司',
          url: 'http://www.cncico.com/'
        },
        {
          name: '江苏交通控股有限公司',
          url: 'http://www.jchc.cn'
        },
        {
          name: '广西交通投资集团',
          url: 'http://www.gx.xinhuanet.com/wq/gxjt/'
        },
        {
          name: '广东省交通投资集团',
          url: 'http://www.gdcg.com.cn'
        },
        {
          name: '山东高速集团有限公司',
          url: 'http://www.sdhsg.com'
        },
        {
          name: '河北建设投资集团',
          url: 'http://www.hecic.com.cn'
        },
        {
          name: '河南高速公路发展有限',
          url: 'http://www.hnew.com.cn'
        },
        {
          name: '江西省投资集团公司',
          url: 'http://www.jxic.com/'
        }
      ],
      options05: [
        {
          name: '国家开发银行',
          url: 'http://www.cdb.com.cn'
        },
        {
          name: '中国进出口银行',
          url: 'http://www.eximbank.gov.cn'
        },
        {
          name: '中国农业发展银行',
          url: 'http://www.adbc.com.cn'
        },
        {
          name: '中国工商银行',
          url: 'http://www.icbc.com.cn'
        },
        {
          name: '中国农业银行',
          url: 'http://www.abchina.com'
        },
        {
          name: '中国银行',
          url: 'http://www.bank-of-china.com'
        },
        {
          name: '中国建设银行',
          url: 'http://www.ccb.com/cn/home/indexv3.html'
        },
        {
          name: '交通银行',
          url: 'http://www.bankcomm.com'
        },
        {
          name: '招商银行',
          url: 'http://www.cmbchina.com'
        },
        {
          name: '信托网',
          url: 'http://www.trust-one.com'
        }
      ],
      value01: '国家部委网站',
      value02: '省直部门网站',
      value03: '省属国企网站',
      value04: '国内同行网站',
      value05: '金融机构网站'
    }
  },
  filters: {
    ellipsis (value) {
      if (!value) return ''
      if (value.length > 60) {
        return value.slice(0,60) + '...'
      }
      return value
    }
  },
  created: function(){
    // var _this = this

    // _this.initSwiper()
  },
  mounted(){
    var _this = this

    // _this.initSwiper();
    _this.getImprotNews();
    _this.getImgNews();
    _this.getJtdtNews();
    _this.getFgsdtNews();
    _this.getGsggNews();
    _this.getZtzlNews();
    _this.getDjgzNews();
    _this.getJjjcNews();
    _this.getXxydNews();
    _this.getZcfgNews();
    _this.getHydtNews();
    _this.getMtjjNews();
    _this.getScrollList();
    _this.getlistZfgs();
  },
  methods: {

    initSwiper(){
      var mySwiper = new Swiper('.swiper-container', {
        autoplay : 2000,
        speed:300,
        direction: 'vertical',
        loop:true,
        slidesPerView: 2,
        spaceBetween : 10,
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
        autoplayDisableOnInteraction: false,   //用户操作swiper之后重新启动autoplay
      });
      console.log('mySwiper :>> ', mySwiper);
    },

    async getImprotNews(){
      var _this = this;
      var { data } = await _this.$http.post(_this.apiUrl + '/news/getImportNews', { company_id: 7 });
      _this.newsTop = data.data.list;
    },
    async getImgNews(){
      var _this = this;
      var { data } = await _this.$http.post(_this.apiUrl + '/news/getImgNews', { company_id: 7 });
      _this.sec01LImg = data.data.list;
    },
    async getJtdtNews(){
      var _this = this;
      var { data } = await _this.$http.post(_this.apiUrl + '/news/getNewsList', {page: 1, group_id: 70});
      _this.newsJtdt = data.data.list.slice(0,9);
    },
    async getFgsdtNews(){
      var _this = this;
      var { data } = await _this.$http.post(_this.apiUrl + '/news/getNewsList', {page: 1, group_id: 8});
      _this.newsFgsdt = data.data.list.slice(0,9);
    },
    async getGsggNews(){
      var _this = this;
      var { data } = await _this.$http.post(_this.apiUrl + '/news/getNewsList', {page: 1, group_id: 82});
      _this.newsGsgg = data.data.list.slice(0,3);
    },
    async getZtzlNews(){
      var _this = this;
      var { data } = await _this.$http.post(_this.apiUrl + '/group/getGrouplistByNavId', {id: 20210202});
      _this.newsZtZl = data.data;
      _this.$nextTick(() => {  // 下一个UI帧再初始化swiper
       this.initSwiper();
      });
    },
    async getDjgzNews(){
      var _this = this;
      var { data } = await _this.$http.post(_this.apiUrl + '/news/getNewsList', {page: 1, group_id: 72});
      _this.newsDjgz = data.data.list.slice(0,5);
    },
    async getJjjcNews(){
      var _this = this;
      var { data } = await _this.$http.post(_this.apiUrl + '/news/getNewsList', {page: 1, group_id: 79});
      _this.newsJjjc = data.data.list.slice(0,5);
    },
    async getXxydNews(){
      var _this = this;
      var { data } = await _this.$http.post(_this.apiUrl + '/news/getNewsList', {page: 1, group_id: 80});
      _this.newsXxyd = data.data.list.slice(0,6);
    },
    async getZcfgNews(){
      var _this = this;
      var { data } = await _this.$http.post(_this.apiUrl + '/news/getNewsList', {page: 1, group_id: 10});
      _this.newsZcfg = data.data.list.slice(0,6);
    },
    async getHydtNews(){
      var _this = this;
      var { data } = await _this.$http.post(_this.apiUrl + '/news/getNewsList', {page: 1, group_id: 13});
      _this.newsHydt = data.data.list.slice(0,6);
    },
    async getMtjjNews(){
      var _this = this;
      var { data } = await _this.$http.post(_this.apiUrl + '/news/getNewsList', {page: 1, group_id: 76});
      _this.newsMtjj = data.data.list.slice(0,6);
    },
    async getScrollList(){
      var _this = this;
      var { data } = await _this.$http.post(_this.apiUrl + '/news/getNewsList', {page: 1, group_id: 85});
      _this.scrollList = data.data.list;
    },
    async getlistZfgs(){
      var _this = this;
      var { data } = await _this.$http.post(_this.apiUrl + '/company/getCompany');
      _this.listZfgs = data.data;
    }
  
  }
}
</script>
<style>
  .index {
    /* min-width: 1020px; */
    min-width: 1200px;
    height: 800px;
    /* padding-top: 365px; */
    padding-top: 400px;
    background-repeat: no-repeat;
    background-position: center 0;
    background-size: 100%;
    background-image: url('../assets/img/banner_index_2.png');
  }
  .index_container {
    padding: 10px;
  }
</style>